export const ENDPOINTS = {
  CHAT: {
    UPLOAD_FILE: (accountId, userId) =>
      `chatapp/uploadFile?accountId=${accountId}&userId=${
        userId || "undefined"
      }`,
    BULK_SEND: "chatapp/bulkSendToConversations",
  },
  ERROR: {
    JS_ERROR: "aviate/JSError/",
  },
  WORKFLOW: {
    FETCH_FLOWS: "flow/v2/flow",
    BULK_ENROLL: "flow/bulkEnroll",
    WORKFLOWS: "workflow/workflows",
    WORKFLOW: (id) => `workflow/workflows/${id}`,
    PUBLISH: (id) => `workflow/workflows/${id}/publish`,
    VALIDATE: (id) => `workflow/workflows/${id}/validate`,
    TRIGGERS: (id) => `workflow/workflows/${id}/triggers`,
    TRIGGER: (id) => `workflow/triggers/${id}`,
    ROTATE_SECRET: (id) => `workflow/triggers/${id}/rotate-secret`,
    NODE_TYPES: "workflow/node-types",
    EMAIL_TEMPLATES: "workflow/email-templates",
    EMAIL_TEMPLATE: (id) => `workflow/email-templates/${id}`,
    EMAIL_PREVIEW: (id) => `workflow/email-templates/${id}/preview`,
    SECRETS: "workflow/secrets",
    SECRET: (id) => `workflow/secrets/${id}`,
    ENROLLMENTS: "workflow/enrollments",
    BULK_ENROLL_V3: "workflow/enrollments/bulk",
    ENROLLMENT_DETAIL: (id) => `workflow/enrollments/${id}`,
    ENROLLMENT_TIMELINE: (id) => `workflow/enrollments/${id}/timeline`,
    ENROLLMENT_CANCEL: (id) => `workflow/enrollments/${id}/cancel`,
    ENROLLMENT_RETRY: (id) => `workflow/enrollments/${id}/retry`,
    ANALYTICS: (id) => `workflow/workflows/${id}/analytics`,
  },
  WHATSAPP: {
    TEMPLATES: "whatsapp/templates",
  },
  CALLS: {
    HANDOVER_RINGING: "calls/handover/ringing",
    HANDOVER_BRIEF: (id) => `calls/call/${id}/handover/brief`,
    HANDOVER_CLAIM: (id) => `calls/call/${id}/handover/claim`,
    HANDOVER_DECLINE: (id) => `calls/call/${id}/handover/decline`,
    HANDOVER_ANALYTICS: "calls/handover/analytics",
    AGENTS: "calls/agents",
    AGENT: (id) => `calls/agents/${id}`,
    VOICE_PREVIEW: "calls/voice-preview",
    LIST: "calls/call",
    BILLING: "calls/billing",
    DETAIL: (id) => `calls/call/${id}`,
    RECORDING: (id) => `calls/call/${id}/recording`,
    TIMELINE: (id) => `calls/call/${id}/timeline`,
    NOTES: (id) => `calls/call/${id}/notes`,
    BARGE: (id) => `calls/call/${id}/barge`,
    END: (id) => `calls/call/${id}/end`,
    TASKS: "calls/tasks",
    TASK: (id) => `calls/tasks/${id}`,
    OUTBOUND: "calls/outbound",
    NUMBERS: "calls/numbers",
    CONFIG: "calls/config",
    TRAIN_TASK: (id) => `calls/tasks/${id}/train`,
    TRAINING_TASKS: "calls/training-tasks",
    RINGCENTRAL_CONVERSATIONS: "calls/ringcentral/conversations",
    RINGCENTRAL_CONVERSATION: (id) => `calls/ringcentral/conversations/${id}`,
    RINGCENTRAL_CALL_LOGS: "calls/ringcentral/call-logs",
    RINGCENTRAL_VOICEMAILS: "calls/ringcentral/voicemails",
    RINGCENTRAL_MEDIA: "calls/ringcentral/media",
    RINGCENTRAL_TRANSCRIPT: "calls/ringcentral/transcript",
    RINGCENTRAL_SEND_SMS: "calls/ringcentral/send",
  },
  ALERTS: {
    CONFIGURATIONS: "alerts/configurations",
    CONFIGURATION: (alertType) => `alerts/configurations/${alertType}`,
    TASKS: "alerts/tasks",
    CLOSE_TASK: (id) => `alerts/tasks/${id}/close`,
    RESYNC_TASK: (id) => `alerts/tasks/${id}/resync`,
  },
  WAWEB: {
    CHANNELS: "waweb/channels",
    STATUS: "waweb/status",
    CONNECT: "waweb/connect",
  },
  WABA: {
    CHANNELS: "chatapp/waba/channels",
    CHANNEL: (id) => `chatapp/waba/channels/${id}`,
    RETRY: (id) => `chatapp/waba/channels/${id}/retry`,
    SIGNUP_START: "chatapp/waba/signup/start",
    SIGNUP_CALLBACK: "chatapp/waba/signup/callback",
  },
  CONTACTS: {
    COLUMNS: "contacts/contactList",
    PAGINATED: "contacts/contactList",
    REPORT: "contacts/report",
    ASSIGNEE: "user/assignee",
    BULK_UPDATE: "contacts/bulkUpdateContact",
    SUMMARY: "contacts/summary",
    TIMELINE: (id) => `contacts/${id}/timeline`,
    SAVED_VIEWS: "contacts/savedViews",
    SAVED_VIEW: (id) => `contacts/savedViews/${id}`,
    FORM: "contacts/Contactform",
    FORM_BY_ID: (id) => `contacts/Contactform/${id}`,
    CREATE: "contacts/contact",
  },
  SALES_CRM: {
    DASHBOARD: "salescrm/dashboard",
    PROPERTIES: "salescrm/properties",
    APPLICANTS: "salescrm/applicants",
    APPLICANT_INTAKE: "salescrm/applicants/intake",
    APPLICANT: (id) => `salescrm/applicants/${id}`,
    VENDORS: "salescrm/vendors",
    LEADS: "salescrm/leads",
    LEAD: (id) => `salescrm/leads/${id}`,
    SALES: "salescrm/sales",
    SALE: (id) => `salescrm/sales/${id}`,
    TASKS: "salescrm/tasks",
    TASK: (id) => `salescrm/tasks/${id}`,
    PROPERTY: (id) => `salescrm/properties/${id}`,
    MATCHES: (propertyId) => `salescrm/properties/${propertyId}/matches`,
    ACTIVITIES: "salescrm/activities",
    PROPERTY_IMAGES: (propertyId) => `salescrm/properties/${propertyId}/images`,
    PROPERTY_IMAGE: (propertyId, imageId) => `salescrm/properties/${propertyId}/images/${imageId}`,
  },
  TAGS: {
    LIST: "tag",
  },
  ANALYTICS: {
    DASHBOARD: "analytics/dashboard",
    DASHBOARDS: "analytics/dashboards",
    OVERVIEW: "analytics/overview",
    WABA: "analytics/waba",
    WASYNC: "analytics/wasync",
    INSTAGRAM: "analytics/instagram",
    VOICE: "analytics/voice",
    WORKFLOWS: "analytics/workflows",
    ATTENTION: "analytics/attention",
    TRENDS: "analytics/trends",
    SALESCRM: "analytics/salescrm",
    TEAM: "analytics/team",
    MY_DAY: "analytics/my-day",
    CONTACTS: "analytics/contacts",
    CAMPAIGNS: "analytics/campaigns",
    CONVERSATIONS: "analytics/conversations",
    AGENTS: "analytics/agents",
    DELIVERY: "analytics/delivery",
    CALLS: "analytics/calls",
    VOICECALL: "analytics/voicecall",
    REFRESH: "analytics/refresh",
    TAGS: "analytics/tags",
    AUTOMATION: "analytics/automation",
    FILTERS: "analytics/filters",
  },
  INSTAGRAM: {
    CONNECT: (accountId) => `instagram/auth/connect/?accountId=${accountId}`,
    CALLBACK: "instagram/auth/callback/",
    ACTIVATE: "instagram/auth/activate/",
    STATUS: (accountId) => `instagram/auth/status/?accountId=${accountId}`,
    DISCONNECT: "instagram/auth/disconnect/",
    POSTS: (accountId) => `instagram/posts/?accountId=${accountId}`,
    COMMENTS: (mediaId) => `instagram/comments/?mediaId=${mediaId}`,
    REPLY_COMMENT: "instagram/comments/reply/",
    MODERATE_COMMENT: "instagram/comments/moderate/",
    SYNC_MEDIA: "instagram/sync/media/",
    SYNC_COMMENTS: "instagram/sync/comments/",
    SEND_MESSAGE: "instagram/messages/send/",
    MESSAGE_HISTORY: (igUserScopedId, accountId) =>
      `instagram/messages/history/?igUserScopedId=${igUserScopedId}&accountId=${accountId}`,
    AUTOMATIONS: (accountId) => `instagram/automations/?accountId=${accountId}`,
    SAVE_AUTOMATION: "instagram/automations/save/",
  },
  SOCIAL: {
    PROFILES: "social/profiles/",
    PROFILE_PAUSE: (id) => `social/profiles/${id}/pause/`,
    BRANDS: "social/brands/",
    BRAND: (id) => `social/brands/${id}/`,
    ASSETS: "social/assets/",
    ASSET: (id) => `social/assets/${id}/`,
    POSTS: "social/posts/",
    POST: (id) => `social/posts/${id}/`,
    VALIDATE_POST: (id) => `social/posts/${id}/validate/`,
    SUBMIT_POST: (id) => `social/posts/${id}/submit/`,
    APPROVAL_DECISION: (id) => `social/approvals/${id}/decision/`,
    SCHEDULE_POST: (id) => `social/posts/${id}/schedule/`,
    PUBLISH_NOW: (id) => `social/posts/${id}/publish-now/`,
    RESCHEDULE_PUBLICATION: (id) => `social/publications/${id}/reschedule/`,
    CANCEL_PUBLICATION: (id) => `social/publications/${id}/cancel/`,
    RETRY_PUBLICATION: (id) => `social/publications/${id}/retry/`,
    CALENDAR: "social/calendar/",
    INBOX_THREADS: "social/inbox/threads/",
    INBOX_THREAD: (id) => `social/inbox/threads/${id}/`,
    INBOX_REPLY: (id) => `social/inbox/threads/${id}/reply/`,
    INBOX_NOTES: (id) => `social/inbox/threads/${id}/notes/`,
    ANALYTICS_OVERVIEW: "social/analytics/overview/",
    ANALYTICS_CONTENT: "social/analytics/content/",
    EXPORTS: "social/exports/",
    QUEUE_SLOTS: "social/queue-slots/",
    AI_CAPTION: "social/ai/caption/",
    IMPORTS: "social/imports/",
    IMPORT_COMMIT: (id) => `social/imports/${id}/commit/`,
  },
};

export const APIs = {
  upload: "chatapp/uploadFile?accountId=1&userId=undefined",
  error: "aviate/JSError/",
  fetchWorkFlows: "flow/v2/flow",
  whatsappTemplate: "whatsapp/templates",
  analyticsDashboard: "analytics/dashboard",
  analyticsDashboards: "analytics/dashboards",
  analyticsOverview: "analytics/overview",
  analyticsContacts: "analytics/contacts",
  analyticsCampaigns: "analytics/campaigns",
  analyticsConversations: "analytics/conversations",
  analyticsAgents: "analytics/agents",
  analyticsDelivery: "analytics/delivery",
  analyticsCalls: "analytics/calls",
  analyticsVoicecall: "analytics/voicecall",
  analyticsTags: "analytics/tags",
  analyticsAutomation: "analytics/automation",
  analyticsFilters: "analytics/filters",
};
